import React from 'react';

const empty = () => <span className="badge badge-warning" style={{width: '100%'}}>No tasks</span>;

export default empty;